import React from "react";

import { Outlet } from "react-router-dom";

import MainNavigation from "../components/MainNavigation";

/**
 * @author
 * @function RootLayout
 **/

const RootLayout = ({ jwt }) => {
  return (
    <>
      <MainNavigation jwt={jwt} />
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default RootLayout;
